export default function loadGoogleMaps(callback) {
  if (window.google && window.google.maps) {
    callback();
  } else {
    window.initGoogleMaps = callback;
    const script = document.createElement("script");
    // eslint-disable-next-line no-undef
    script.src = `https://maps.googleapis.com/maps/api/js?language=${LANGUAGE_CODE}&key=${GOOGLE_MAPS_API_KEY}&libraries=places&loading=async&callback=initGoogleMaps`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }
}